import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Hide } from 'pcln-design-system'
import { TRIP_TYPE, CABIN_CLASS, TRIP_TYPE_MENU_PROPS, CABIN_CLASS_MENU_PROPS } from './constants'
import { StyledMenu, StyledMenuItem } from './ChangeSearchOptions.style'
import { ChangeSearchFlexDates } from './ChangeSearchFlexDates/ChangeSearchFlexDates'

const ChangeSearchOptions = ({
  tripType,
  setTripType,
  rtReturnSlice,
  updateSlicesForTripType,
  cabinClass,
  setCabinClass,
  useFlexDates,
  setUseFlexDates,
  displayFlexibleDatesCheckbox,
  isReshopExperience,
}) => (
  <Flex alignItems='center' mb={1}>
    <Box data-testid='trip-type-menu'>
      <StyledMenu {...TRIP_TYPE_MENU_PROPS} buttonText={TRIP_TYPE[tripType]}>
        {Object.keys(TRIP_TYPE)
          // Hide Multi-destination from the trip-type dropdown for reshop
          .filter((tt) => (isReshopExperience ? tt !== 'MD' : tt))
          .map((tt) => (
            <StyledMenuItem
              data-testid={`trip-type-${tt}`}
              key={tt}
              selected={tt === tripType}
              onClick={() => {
                setTripType(tt)
                updateSlicesForTripType(tt, rtReturnSlice)
              }}
            >
              {TRIP_TYPE[tt]}
            </StyledMenuItem>
          ))}
      </StyledMenu>
    </Box>

    {/* Hide cabin class dropdown for reshop */}
    {!isReshopExperience && (
      <Box data-testid='cabin-class-menu'>
        <StyledMenu {...CABIN_CLASS_MENU_PROPS} buttonText={CABIN_CLASS[cabinClass]}>
          {Object.keys(CABIN_CLASS).map((cc) => (
            <StyledMenuItem
              key={cc}
              selected={cc === cabinClass}
              onClick={() => {
                setCabinClass(cc)
              }}
            >
              {CABIN_CLASS[cc]}
            </StyledMenuItem>
          ))}
        </StyledMenu>
      </Box>
    )}

    {displayFlexibleDatesCheckbox && (
      <Hide xs sm md lg ml='auto' mr='calc(50% - 280px)' width='280px'>
        <Box>
          <ChangeSearchFlexDates
            useFlexDates={useFlexDates}
            tripType={tripType}
            setUseFlexDates={setUseFlexDates}
          />
        </Box>
      </Hide>
    )}
  </Flex>
)

ChangeSearchOptions.propTypes = {
  tripType: PropTypes.string,
  setTripType: PropTypes.func,
  rtReturnSlice: PropTypes.object,
  updateSlicesForTripType: PropTypes.func,
  cabinClass: PropTypes.string,
  setCabinClass: PropTypes.func,
  logFlexibleDatesEvent: PropTypes.func,
  stacked: PropTypes.bool,
  displayFlexibleDatesCheckbox: PropTypes.bool,
  useFlexDates: PropTypes.bool,
  setUseFlexDates: PropTypes.func,
  isReshopExperience: PropTypes.bool,
}

export { ChangeSearchOptions }
